'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isProductOwnedAdapter = require('self-service-api/adapters/isProductOwnedAdapter');

var _isProductOwnedAdapter2 = _interopRequireDefault(_isProductOwnedAdapter);

var _ProductTierOrders = require('self-service-api/constants/ProductTierOrders');

var _ProductTierOrders2 = _interopRequireDefault(_ProductTierOrders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasHigherTieredProductAdapter = function hasHigherTieredProductAdapter(productData, parcels, merchandiseId) {
  var tieredProductsGroup = _ProductTierOrders2.default.filter(function (productTierOrder) {
    return productTierOrder.indexOf(merchandiseId) !== -1;
  })[0];

  if (!tieredProductsGroup) {
    return false;
  }

  var tierIndex = tieredProductsGroup.indexOf(merchandiseId);

  var higherTieredProductGroups = tieredProductsGroup.slice(tierIndex + 1, tieredProductsGroup.length);

  return higherTieredProductGroups.some(function (tieredMerchandiseId) {
    return (0, _isProductOwnedAdapter2.default)(productData, parcels, tieredMerchandiseId);
  });
};

exports.default = hasHigherTieredProductAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/hasHigherTieredProductAdapter.js
// module id = 285
// module chunks = 3 4 5